import Box from '@mui/material/Box';
import { Container, useTheme } from '@mui/material';
import { CSSProperties } from 'react';

export interface OnboardingDesktopLayoutProps {
  children?: JSX.Element
  customBanner?: JSX.Element | null
  optionalDesktopContainerStyle?: CSSProperties;
}
export default function OnboardingDesktopLayout({
  children,
  customBanner,
  optionalDesktopContainerStyle,
}: OnboardingDesktopLayoutProps) {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          postion: 'relative',
        }}
      >
        {customBanner && (
          <Box
            sx={{
              flex: 1,
              marginTop: theme.spacing(6),
            }}
          >
            {customBanner}
          </Box>
        )}
        <Box
          sx={{
            flex: 1,
          }}
        >
          <Container maxWidth='sm'
            sx={{
              textAlign: 'center',
              marginTop: theme.spacing(13.5),
              marginLeft: customBanner ? theme.spacing(7.5) : 'auto',
              ...optionalDesktopContainerStyle,
            }}
          >
            {children}
          </Container>
        </Box>
      </Box>
    </>
  );
}
